module.exports = __webpack_public_path__ + "assets/img/dzh-29.1d6e3c66.gif";